import React, { useEffect } from "react"; // Make sure this is at the top of the file
import { FormControl } from "react-bootstrap";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete"; // Ensure this is also present
import {
  cachePlaceId,
  cacheGeocodeResult,
  getCachedGeocodeResult,
  trackGoogleApiCall,
} from "../../../common/helpers/Utils";

const LocationSearchInput = ({
  placeholder,
  location,
  clearValue,
  setLocation,
}) => {
  const {
    ready,
    value,
    setValue,
    suggestions: { status, data },
    clearSuggestions,
  } = usePlacesAutocomplete({
    debounce: 300,
  });

  console.log("location data", data);

  useEffect(() => {
    if (location === "") setValue("");
  }, [location]);

  useEffect(() => {
    setValue("");
  }, [clearValue]);

  // Track Places Autocomplete API call each time suggestions are returned
  useEffect(() => {
    if (status === "OK") {
      trackGoogleApiCall("PlacesAutocomplete");
    }
  }, [status]);

  const parseAddressParts = (description) => {
    const parts = description
      .split(",")
      .map((p) => p.trim())
      .filter((p) => p);
    let country = parts.pop() || "";
    let state = parts.pop() || "";
    let city = parts.pop() || "";
    let locality = parts.join(",") || "";
    return { locality, city, state, country };
  };

  const extractFeatureName = (components) => {
    const routesArray = [
      "route",
      "sublocality",
      "sublocality_level_1",
      "sublocality_level_2",
      "neighborhood",
    ];
    for (const route of routesArray) {
      const component = components.find((comp) => comp.types.includes(route));
      if (component) return component.long_name;
    }
    return "";
  };

  const handleSelect = async (suggestion) => {
    const { description, place_id } = suggestion;
    // Cache the place_id by description (place_ids are safe to store per Google ToS)
    cachePlaceId(description, place_id);

    try {
      // Check geocode cache first — skip API call if we've resolved this place_id before
      const cached = getCachedGeocodeResult(place_id);

      let featureName;
      if (cached && cached.featureName !== undefined) {
        // Cache was written by this component — has featureName field
        featureName = cached.featureName;
      } else {
        const results = await getGeocode({ address: description });
        trackGoogleApiCall("getGeocode");
        const components = results[0].address_components;
        featureName = extractFeatureName(components);
        const { locality, city, state, country } =
          parseAddressParts(description);
        const latLng = await getLatLng(results[0]);

        const locationData = {
          description,
          featureName,
          locality,
          city,
          state,
          country,
          lat: latLng.lat,
          lng: latLng.lng,
        };

        // Store resolved result for future lookups
        cacheGeocodeResult(place_id, locationData);
      }

      setValue(description, false);
      setLocation(featureName);
      clearSuggestions();
    } catch (error) {
      console.error("Geocode error: ", error);
    }
  };

  return (
    <div className="position-relative w-100">
      <FormControl
        type="text"
        value={value}
        onChange={(e) => {
          let value = e.target.value;
          let trimmedValue = value.replace(/\s+/g, " ").trimStart();
          setValue(trimmedValue);
        }}
        placeholder={placeholder}
        disabled={!ready}
      />
      {status === "OK" && data.length > 0 && (
        <ul className="listData list-unstyled border bg-white position-absolute w-100 z-10">
          {data.map((suggestion) => (
            <li
              key={suggestion.place_id}
              className="px-2 py-1 cursor-pointer border-bottom"
              onClick={() => handleSelect(suggestion)}
            >
              {suggestion.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LocationSearchInput;
